<template>
  <div class="common-table">
    <div class="news-banner">
      <img :src="commonbg" width="100%" alt="">
    </div>
    <div class="news-body">
      <div class="titleTip">
        <h3>行业要闻</h3>
        <el-divider></el-divider>
      </div>
      <div class="activity-part">
        <div class="current-part">
          <news-list></news-list>
          <!-- <news-list @whichNewsToShow="showNews"></news-list> -->
        </div>
        <div class="his-part">
          <news-other></news-other>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as newsApi from '@/api/frontApi/frontNews';
import newsList from './newsList';
import newsOther from './newsOther';
export default {
  data() {
    return {
      receiveMsg: null,
      activeName: 'second',
      newsObj: {
        title: '',
        subTitle: '',
        content: '',
        readNo: null,
        newsAuthor: '',
        time: '',
        admire: null,
        newsType: '',
        newsTypeName: '',
        isCopy: 1,
        newsId: ''
      },
      topTenList: [],
      isEntity: false,
      isAdmired: false
    };
  },
  computed: {
    commonbg() {
      return this.$store.state.commonbg;
    }
  },
  components: {
    newsList,
    newsOther
  },
  created() {
    // this.topTenNews();
  },
  beforeDestroy() {
    // this.sendViewd(this.newsObj.newsId);
    // this.callBackAdmire(this.newsObj.newsId);
  },
  methods: {
    viewNewsById(newsID) {
      newsApi.getNewsById({ newsId: newsID }).then(res => {
        this.newsObj.title = res.data.newsTitle;
        this.newsObj.subTitle = res.data.newsSubtitle;
        this.newsObj.content = res.data.newsText;
        this.newsObj.readNo = this.viewed(res.data.newsReadNum);
        this.newsObj.newsAuthor = res.data.newsAuthor;
        this.newsObj.time = res.data.newsCreateTime;
        this.newsObj.admire = res.data.newsSupportNum;
        this.newsObj.newsType = res.data.newsType;
        this.newsObj.newsTypeName = res.data.newsTypeName;
        this.newsObj.newsId = newsID;
        // 1,原创；2,转载
        this.newsObj.isCopy = 1;
      });
    }
  }
};
</script>
<style scoped>
.news-banner {
  width: 100%;
  margin-bottom: 20px;
}
.news-body {
  width: 65%;
  margin-left: 17.5%;
}
.activity-part {
  width: 100%;
  overflow: hidden;
  padding-left: 1%;
}
.current-part {
  float: left;
  width: 65%;
}
.list-news-show {
  min-height: 120px;
  width: 100%;
  margin-left: 20px;
}
.his-part {
  float: left;
  width: 27%;
  margin-left: 5%;
}
.find-part {
  margin-bottom: 15px;
}
.his-item {
  overflow: hidden;
  margin-bottom: 5px;
}
.his-img {
  float: left;
}
.his-text {
  float: left;
  margin-left: 15px;
}
.current-part h3 {
  text-align: center;
}
img {
  vertical-align: middle;
}
.textUtil img {
  margin-top: -3px;
}
.is-original {
  padding: 5px 10px;
  background-color: #66b1ff;
  color: #fff;
  border-radius: 4px;
}
.titleTip {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/news/news.vue